import AuthRoute from 'components/AuthRoute'
import {
  READ_CLIENT,
  READ_COMPANY,
  READ_EXPENSE,
  READ_EXPENSE_TYPE,
  READ_INVOICE,
  READ_LOCATION,
  READ_MIKROTIK,
  READ_PAYMENT_ENTRY,
  READ_PAYMENT_TYPE,
  READ_PRODUCT,
  READ_PROMOTION,
  READ_PURCHASE,
  READ_PURCHASE_QUOTATION,
  READ_PURCHASE_QUOTATION_REQUEST,
  READ_REPORT,
  READ_ROLE,
  READ_SALE,
  READ_SESSION,
  READ_SUBSCRIPTION,
  READ_SUPPLIER,
  READ_TICKET,
  READ_TICKET_TYPE,
  READ_USER,
  READ_WAREHOUSE,
  READ_WAREHOUSE_ENTRY,
  READ_CORP,
  READ_ONU,
  READ_ACCOUNT,
  READ_TICKET_CANCELLATION,
  READ_PUESTO,
  READ_EMPLOYEE,
  READ_VEHICLE_BRAND,
  READ_VEHICLE,
  READ_EMPLOYEE_CONCEPT,
  CREATE_EMPLOYEE_CONCEPT,
  READ_EMPLOYEE_INCIDENT,
  READ_EMPLOYEE_INCIDENT_TYPE,
  READ_CALL,
  VIEW_CALL,
  TEST_PERMISSION,
  READ_PRODUCT_FAMILY,
  READ_PROPERTY,
  READ_BRAND,
  READ_EQUIPMENT,
  READ_DEPOSIT,
  READ_PURCHASE_REQUEST,
  READ_FIXED_ASSET,
  READ_PROJECT,
  READ_COLLECTOR_VISIT,
  READ_SHIPMENT,
  READ_BANK,
  READ_INVOICE_PAYMENT,
} from 'config/permissions'
import EquipmentIndex from 'core/equipment/pages/EquipmentIndex'
import VehicleIncidentTypeIndex from 'core/vehicleIncidentType/pages/VehicleIncidentTypeIndex'
import React, { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'

const ClientRouter = lazy(() => import('core/client/ClientRouter'))
const ClientCorporateRouter = lazy(() => import('core/client_corporate/ClientCorporateRouter'))
const ClientVisitRouter = lazy(() => import('core/clientVisit/ClientVisitRouter'))

const CompanyRouter = lazy(() => import('core/company/CompanyRouter'))
// const DashboardRouter = lazy(() => import('core/dashboard/DashboardRouter'))
const ExpenseRouter = lazy(() => import('core/expense/ExpenseRouter'))
const ExpenseTypeRouter = lazy(() =>
  import('core/expenseType/ExpenseTypeRouter')
)
const InvoiceRouter = lazy(() => import('core/invoice/InvoiceRouter'))
const LocationRouter = lazy(() => import('core/location/LocationRouter'))
/* const MaterialRequestRouter = lazy(() =>
  import('core/materialRequest/MaterialRequestRouter')
) */
const PurchaseRequestRouter = lazy(() => import('core/purchaseRequest/PurchaseRequestRouter'))

const MikrotikRouter = lazy(() => import('core/mikrotik/MikrotikRouter'))
const OnuRouter = lazy(() => import('core/onu/OnuRouter'))

const PaymentEntryRouter = lazy(() =>
  import('core/paymentEntry/PaymentEntryRouter')
)
const PaymentTypeRouter = lazy(() =>
  import('core/paymentType/PaymentTypeRouter')
)
const ProductRouter = lazy(() => import('core/product/ProductRouter'))
const PromotionRouter = lazy(() => import('core/promotion/PromotionRouter'))
const PurchaseRouter = lazy(() => import('core/purchase/PurchaseRouter'))
const ShipmentRouter = lazy(() => import('core/shipment/ShipmentRouter'))
const PurchaseQuotationRouter = lazy(() =>
  import('core/purchaseQuotation/PurchaseQuotationRouter')
)
const PurchaseQuotationRequestRouter = lazy(() =>
  import('core/purchaseQuotationRequest/PurchaseQuotationRequestRouter')
)
const ReportRouter = lazy(() => import('core/report/ReportRouter'))
const RoleRouter = lazy(() => import('core/role/RoleRouter'))
const SaleRouter = lazy(() => import('core/sale/SaleRouter'))
const SessionRouter = lazy(() => import('core/session/SessionRouter'))
const SettingsRouter = lazy(() => import('core/settings/SettingsRouter'))
const SubscriptionRouter = lazy(() =>
  import('core/subscription/SubscriptionRouter')
)
const SupplierRouter = lazy(() => import('core/supplier/SupplierRouter'))
const TicketRouter = lazy(() => import('core/ticket/TicketRouter'))
const TicketTypeRouter = lazy(() => import('core/ticketType/TicketTypeRouter'))
const TicketSubtypeRouter = lazy(() => import('core/ticketSubtype/TicketSubtypeRouter'))
const TicketCancellationTypeRouter = lazy(() => import('core/ticketCancellationCategories/ticketCancellationTypeRouter'))
const UserRouter = lazy(() => import('core/user/UserRouter'))
const PuestoRouter = lazy(() => import('core/puesto/PuestoRouter'))
const VehicleRouter = lazy(() => import('core/vehicle/VehicleRouter'))
const VehicleBrandRouter = lazy(() => import('core/vehicleBrand/vehicleBrandRouter'))
const EmployeeRouter = lazy(() => import('core/employee/EmployeeRouter'))
const FixedAssetsRouter = lazy(() => import('core/fixedAssets/FixedAssetsRouter'))
const WarehouseRouter = lazy(() => import('core/warehouse/WarehouseRouter'))
const WarehouseEntryRouter = lazy(() =>
  import('core/warehouseEntry/WarehouseEntryRouter')
)
const EmployeeConceptsRouter = lazy(() => import('core/employeeConcepts/EmployeeConceptsRouter'))
const EmployeeIncidentsRouter = lazy(() => import('core/employeeIncidents/EmployeeIncidentsRouter'))
const EmployeeIncidentsTypeRouter = lazy(() => import('core/employeeIncidentsType/EmployeeIncidentsTypeRoute'))
const AccountRouter = lazy(() => import('core/account/AccountRuter'))
const TaxRouter = lazy(() => import('core/tax/TaxRouter'))
const PayrollsRouter = lazy(() => import('core/payroll/PayrollRouter'))
const NotificationRouter = lazy(() => import('core/notifications/NotificationRouter'))
const VehicleIncidentTypeRouter = lazy(() => import('core/vehicleIncidentType/VehicleIncidentTypeRouter'))
const TaskRouter = lazy(() => import('core/task/TaskRouter'))
const CallRouter = lazy(() => import('core/calls/CallRouter'))
const OltRouter = lazy(() => import('core/olt/OltRouter'))
const ExpenseRecurrenceRouter = lazy(() => import('core/expenseRecurrence/ExpenseRecurrenceRouter'))
const ProductFamilyRouter = lazy(() => import('core/productFamily/ProductFamilyRouter'))
const PropertyRouter = lazy(() => import('core/property/PropertyRouter'))
const BrandRouter = lazy(() => import('core/brand/BrandRouter'))
const EquimentRouter = lazy(() => import('core/equipment/EquipmentRouter'))
const DepositRouter = lazy(() => import('core/deposit/DepositRouter'))
const ProjectRouter = lazy(() => import('core/project/ProjectRouter'))
const BankRouter = lazy(() => import('core/bank/BankRouter'))
const InvoicePaymentRouter = lazy(() => import('core/invoicePayment/InvoicePaymentRouter'))
const RackRouter = lazy(() => import('core/rack/RackRouter'))



export default function AppRouter() {
  return (
    <React.Fragment>
      <Suspense fallback={<div>Loading...</div>}>
        <AuthRoute can={READ_CLIENT} path='/client' component={ClientRouter} />
        <AuthRoute can={READ_CORP} path='/clientCorporate' component={ClientCorporateRouter} />
        <AuthRoute can={READ_COLLECTOR_VISIT} path='/client-visit' component={ClientVisitRouter} />
        <AuthRoute
          can={READ_COMPANY}
          path='/company'
          component={CompanyRouter}
        />

        {/* <AuthRoute
          can={READ_DASHBOARD}
          path='/dashboard'
          component={DashboardRouter}
        /> */}

        <AuthRoute
          can={READ_EXPENSE}
          path='/expense'
          component={ExpenseRouter}
        />

        <AuthRoute
          can={READ_EXPENSE_TYPE}
          path='/expense-type'
          component={ExpenseTypeRouter}
        />

        <AuthRoute
          can={READ_INVOICE}
          path='/invoice'
          component={InvoiceRouter}
        />

        <AuthRoute
          can={READ_LOCATION}
          path='/location'
          component={LocationRouter}
        />

        {/*  <AuthRoute
          can={READ_MATERIAL_REQUEST}
          path='/material-request'
          component={MaterialRequestRouter}
        /> */}

        <AuthRoute
          can={READ_PURCHASE_REQUEST}
          path='/purchase-request'
          component={PurchaseRequestRouter}
        />

        <AuthRoute
          can={READ_MIKROTIK}
          path='/mikrotik'
          component={MikrotikRouter}
        />
        <AuthRoute
          can={READ_ONU}
          path='/onus'
          component={OnuRouter}
        />

        <AuthRoute
          can={READ_PAYMENT_ENTRY}
          path='/payment-entry'
          component={PaymentEntryRouter}
        />

        <AuthRoute
          can={READ_PAYMENT_TYPE}
          path='/payment-type'
          component={PaymentTypeRouter}
        />

        <AuthRoute
          can={READ_PRODUCT}
          path='/product'
          component={ProductRouter}
        />

        <AuthRoute
          can={READ_PROMOTION}
          path='/promotion'
          component={PromotionRouter}
        />

        <AuthRoute
          can={READ_PURCHASE}
          path='/purchase'
          component={PurchaseRouter}
        />
        <AuthRoute
          can={READ_SHIPMENT}
          path='/shipment'
          component={ShipmentRouter}
        />

        <AuthRoute
          can={READ_PURCHASE_QUOTATION}
          path='/purchase-quotation'
          component={PurchaseQuotationRouter}
        />

        <AuthRoute
          can={READ_PURCHASE_QUOTATION_REQUEST}
          path='/purchase-quotation-request'
          component={PurchaseQuotationRequestRouter}
        />

        <AuthRoute can={READ_REPORT} path='/report' component={ReportRouter} />

        <AuthRoute can={READ_ROLE} path='/role' component={RoleRouter} />

        <AuthRoute can={READ_SALE} path='/sale' component={SaleRouter} />

        <AuthRoute can={READ_ACCOUNT} path='/account' component={AccountRouter} />
        <AuthRoute can={READ_ACCOUNT} path='/tax' component={TaxRouter} />

        <AuthRoute
          can={READ_SESSION}
          path='/session'
          component={SessionRouter}
        />

        <AuthRoute
          can={READ_SUBSCRIPTION}
          path='/subscription'
          component={SubscriptionRouter}
        />

        <AuthRoute
          can={READ_SUPPLIER}
          path='/supplier'
          component={SupplierRouter}
        />
        <AuthRoute can={READ_VEHICLE_BRAND} path='/vehicle-brand' component={VehicleBrandRouter} />
        <AuthRoute can={READ_VEHICLE} path='/vehicle' component={VehicleRouter} />
        <AuthRoute can={READ_TICKET} path='/ticket' component={TicketRouter} />

        <AuthRoute
          can={READ_TICKET_TYPE}
          path='/ticket-type'
          component={TicketTypeRouter}
        />
        <AuthRoute
          can={READ_TICKET_TYPE}
          path='/ticket-Subtype'
          component={TicketSubtypeRouter}
        />
        <AuthRoute
          can={READ_TICKET_CANCELLATION}
          path='/ticketCancellation'
          component={TicketCancellationTypeRouter}
        />

        <AuthRoute can={READ_USER} path='/user' component={UserRouter} />
        <AuthRoute can={READ_EMPLOYEE} path='/empleado' component={EmployeeRouter} />
        <AuthRoute can={READ_PUESTO} path='/puesto' component={PuestoRouter} />
        <AuthRoute
          can={READ_WAREHOUSE}
          path='/warehouse'
          component={WarehouseRouter}
        />

        <AuthRoute
          can={READ_WAREHOUSE_ENTRY}
          path='/warehouse-entry'
          component={WarehouseEntryRouter}
        />

        <AuthRoute can={READ_EMPLOYEE_CONCEPT} path="/employee-concepts" component={EmployeeConceptsRouter} />

        <AuthRoute can={READ_EMPLOYEE_INCIDENT} Route path="/employee-incidents" component={EmployeeIncidentsRouter} />

        <AuthRoute can={READ_EMPLOYEE_INCIDENT_TYPE} path="/employee-incidents/type" component={EmployeeIncidentsTypeRouter} />

        {/* Rutas de notificaciones para pruebas */}
        <Route path="/notifications" component={NotificationRouter} />


        <Route path="/vehicle-incidents-type" component={VehicleIncidentTypeRouter} />

        <Route path="/payroll" component={PayrollsRouter} />

        <Route path="/task" component={TaskRouter} />

        <Route path="/calls" component={CallRouter} />

        <Route path="/olt" component={OltRouter} />

        <AuthRoute can={READ_EXPENSE} path="/expense-recurrence" component={ExpenseRecurrenceRouter} />
        <AuthRoute can={READ_PRODUCT_FAMILY} path="/product-family" component={ProductFamilyRouter} />
        <AuthRoute can={READ_PROPERTY} path="/property" component={PropertyRouter} />
        <AuthRoute can={READ_BRAND} path="/brand" component={BrandRouter} />
        <AuthRoute can={READ_EQUIPMENT} path="/equipment" component={EquimentRouter} />

        <AuthRoute can={READ_DEPOSIT} path="/deposit" component={DepositRouter} />
        <AuthRoute can={READ_FIXED_ASSET} path="/fixed-assets" component={FixedAssetsRouter} />
        <AuthRoute can={READ_PROJECT} path="/project" component={ProjectRouter} />
        <AuthRoute can={READ_BANK} path="/bank" component={BankRouter} />
        <AuthRoute can={READ_INVOICE_PAYMENT} path="/invoice-payment" component={InvoicePaymentRouter} />
        <AuthRoute can={TEST_PERMISSION} path="/rack" component={RackRouter} />

        <Route component={SettingsRouter} />
      </Suspense>
    </React.Fragment>
  )
}
